import { css } from '@emotion/core';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Colors, Link, Shadows, Typography } from '@zapier/design-system';
import { emitUserInteractionEvent } from '../../../utils/avroEvents';
const Styles = labelStyles('Submenu', {
    root: css `
    background-color: ${Colors.neutral100};
    border: 1px solid ${Colors.neutral400};
    border-radius: 3px;
    padding: 20px;
    box-shadow: ${Shadows.elevation20};
  `,
    list: css `
    display: grid;
    grid-template-columns: 100%;
    gap: 5px;
  `,
    link: css `
    ${Typography.base};
    display: block;
    border-radius: 3px;
    color: ${Colors.neutral800};
    line-height: 25px;
    font-size: 18px;
    font-weight: 600;
    padding: 10px;
    text-decoration: none;

    &:hover,
    &:focus {
      color: ${Colors.neutral800};
      background-color: ${Colors.cream};
      outline: none;
    }
  `,
    linkInner: css `
    transform: translateY(1px);
  `,
    linkTitle: (hasDescription) => css `
    display: block;
    font-weight: ${hasDescription ? 600 : 500};
  `,
    linkDescription: css `
    display: block;
    margin-top: 5px;
    color: ${Colors.neutral800};
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
  `,
});
const SubmenuLink = (props) => {
    const hasDescription = !!props.description;
    const handleHover = () => {
        emitUserInteractionEvent({
            event_action: 'hover',
            option_selected: `UniversalLayout SubMenu: ${props.href ? props.href : props.text}`,
        });
    };
    const handleClick = () => {
        emitUserInteractionEvent({
            event_action: 'click',
            option_selected: `UniversalLayout SubMenu: ${props.href ? props.href : props.text}`,
        });
    };
    return (isolateComponent(Link, { color: null, css: Styles.link, href: props.href || undefined, role: "menuitem", onClick: () => handleClick(), onMouseEnter: () => handleHover() },
        isolateComponent("div", { css: Styles.linkInner },
            isolateComponent("p", { css: Styles.linkTitle(hasDescription) }, props.text),
            props.description && (isolateComponent("p", { css: Styles.linkDescription }, props.description)))));
};
const Submenu = (props) => {
    const linkItems = props.links.map((link) => {
        return (isolateComponent("li", { key: link.text, role: "none" },
            isolateComponent(SubmenuLink, Object.assign({}, link))));
    });
    return (isolateComponent("div", { css: Styles.root },
        isolateComponent("ul", { css: Styles.list, role: "menu" }, linkItems)));
};
export default Submenu;
//# sourceMappingURL=Submenu.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
